<script>
import CommentPanel from '@components/feed/comment-panel'
import CommentForm from '@components/feed/comment-form'
import LinkView from '@components/feed/link-view'
import VideoPlayer from '@components/feed/video'
import ReadMore from 'vue-read-more'
import Vue from 'vue'
import mixins from '@utils/mixins'
import ModifyFeed from '@components/content/update'
import ConvertContent from '@filters/convert-content'
import store from '@state/store'
import ImageBlock from './image-block'
import moment from 'moment';

const _ = require('lodash')
Vue.use(ReadMore)
export default {
  filters: {
    convertContent: ConvertContent,
  },
  components: {
    CommentPanel,
    CommentForm,
    LinkView,
    ModifyFeed,
    ImageBlock,
    VideoPlayer,
  },
  mixins: [mixins],
  props: {
    feed: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      videoPlayerKey: 0,
      videoOptions: {
        autoplay: false,
        controls: true,
        responsive: true,
        preload: true,
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        // plugins: {
        //   videoJsResolutionSwitcher: {
        //     default: '720x480', // Default resolution [{Number}, 'low', 'high'],
        //     dynamicLabel: true
        //   }
        // },
        poster:'',
        sources: [
          {
            src:
              'SampleVideo_1280x720_2mb.mp4',
              type: 'video/mp4',
              label: '1280x720',
          },
          {
            src:
              'SampleVideo_720x480_1mb.mp4',
              type: 'video/mp4',
              label: '720x480',
          },
          {
            src:
              'SampleVideo_640x360_2mb.mp4',
              type: 'video/mp4',
              label: '640x360',
          },
          {
            src:
              'SampleVideo_360x240_1mb.mp4',
              type: 'video/mp4',
              label: '360x240',
          },
        ]
      },
      loading: false,
      reportStatus: false,
      deleted: false,
      isUpdated: false,
      isConfirmed: true,
      deleted_message: null,
      slide_controller: true,
      feed_type: '',
      post_author: null,
      post_comment: this.feed.post_comments,
      is_liked: this.feed.is_liked,
      is_scraped: this.feed.is_scraped,
      isLoaded: false,
      profile: null,
      openModal: false,
      openModalDelete: false,
      openModalShare: false,
      content_lenght: 0,
      report: {
        type: 'illegal_or_obscene',
        options: [
          {
            text: 'Illegal or obscene',
            value: 'illegal_or_obscene',
          },
          {
            text: 'Invalid spam',
            value: 'spam',
          },
          {
            text: 'Damage or violence to others',
            value: 'damage_or_violence',
          },
          {
            text: 'etc',
            value: 'etc',
          },
        ],
        content: '',
        post_id: null,
      },
      form_report: {
        type: null,
        post_id: null,
        content: null,
      },
      post_scrap: null,
      comments: null,
      total_post_likes: 0,
      total_post_scraps: 0,
      total_post_comments: 0,
      urlShare: null,
      is_youtube: false,
      video_id: '',
    }
  },
  watch: {
    feed() {
      this.initFeed()
    },
  },
  created() {
    if (this.feed) {
      this.initFeed()
    }
    this.profile = this.$store.state.authenticate.userProfile.data
  },
  methods: {
    timeAgoSinceDate(fromDate="2024-03-12 09:55:00", toTimezone="Asia/Seoul") {

        // console.log("fromDate  == " +fromDate+"  --  "+toTimezone)
        const fromDateE = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS");// .tz('Asia/Seoul');
        // const currentDate = moment.tz(toTimezone);
        const currentDate = moment().tz('Asia/Seoul');// .format('YYYY-MM-DD HH:mm:ss.SSS');
        // console.log("currentDate  == " + moment().tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss.SSS'));
        // currentDate = moment.tz(currentDate, "YYYY-MM-DD HH:mm:ss.SSS", toTimezone);
        // Parse the target date string and convert it to the specified timezone
        // const fromDateE = moment.tz(fromDate, "YYYY-MM-DD HH:mm:ss.SSS", toTimezone);
        // currentDate = moment.tz(currentDate, "YYYY-MM-DD HH:mm:ss.SSS", toTimezone);
        // console.log(fromDateE);


        // // Calculate the interval in minutes
          const interval = currentDate.diff(fromDateE, 'minutes');

         // console.log(interval)

        if (interval > 0) {
          // Year
            let toYear = moment().tz('Asia/Seoul').format('YYYY');
            let fromYear = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('YYYY');
            if(toYear>fromYear)
              return `${moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('MMMM DD, YYYY')}`;

          // Month
            let toMonth = moment().tz('Asia/Seoul').format('MM');
            let fromMonth = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('MM');
            if(toMonth>fromMonth)
              return `${moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('MMMM DD')}`;

          // Day
            let toDay = moment().tz('Asia/Seoul').format('DD');
            let fromDay = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('DD');
            if(toDay>fromDay) {
              let intervalD = toDay - fromDay
              return intervalD == 1 ? "Yesterday" : intervalD + " " + "days ago"
            }

          // Hour
            let toHour = moment().tz('Asia/Seoul').format('HH');
            let fromHour = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('HH');
            if(toHour>fromHour) {
              return (toHour-fromHour) + " " + "hr. ago"
            }

          // Minute
            let toMinute = moment().tz('Asia/Seoul').format('mm');
            let fromMinute = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('mm');
            if(toMinute>fromMinute) {
              return (toMinute - fromMinute) + " " + "min. ago"
            }

          // Second
            let toSecond = moment().tz('Asia/Seoul').format('ss');
            let fromSecond = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('ss');
            if(toSecond>=fromSecond) {
              return (toSecond - fromSecond) < 0 ? 1 : (toSecond - fromSecond) + " " + "sec. ago"
            }
            // if (interval < 60)
            //   return `${interval} min. ago`;
            // const hours = Math.floor(interval / 60);
            // if (hours < 24) return `${hours} hr. ago`;
            // const days = Math.floor(interval / (60 * 24));
            // if (days < 8) return `${days === 1 ? 'Yesterday' : days+' days ago'}`;
            // const months = Math.floor(interval / (60 * 24 * 30));
            // if (months < 12) return `${moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('MMMM DD')}`;
            // const years = Math.floor(interval / (60 * 24 * 30 * 12));
            // return `${moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('MMMM DD, YYYY')}`;
            // if (interval < 60) return `${interval} minute${interval === 1 ? '' : 's'} ago`;
            // const hours = Math.floor(interval / 60);
            // if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
            // const days = Math.floor(interval / (60 * 24));
            // if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
            // const months = Math.floor(interval / (60 * 24 * 30));
            // if (months < 12) return `${months} month${months === 1 ? '' : 's'} ago`;
            // const years = Math.floor(interval / (60 * 24 * 30 * 12));
            // return `${years} year${years === 1 ? '' : 's'} ago`;
        }
            // second
            let toSecond = moment().tz('Asia/Seoul').format('ss');
            let fromSecond = moment(fromDate, "YYYY-MM-DD HH:mm:ss.SSS").format('ss');
            // if(toSecond>=fromSecond) {
              return (toSecond - fromSecond) < 0 ? 1 : (toSecond - fromSecond) + " " + "sec. ago"
            // }
        // return 'Just now';
    },
    initFeed() {
      this.is_youtube = false
      this.video_id = null
      this.isLoaded = true
      this.post_author = this.feed.post_author.data
      if (this.feed.hasOwnProperty('post_location')) {
        this.post_location = this.feed.post_location.data
      } else {
        this.post_location = ''
      }
      if (this.feed.hasOwnProperty('post_link')) {
        this.post_link = this.feed.post_link.data
        let video = this.getVideoID(this.post_link.url)
        switch (video.type) {
          case 'youtube':
            if (video.id) {
              this.is_youtube = true
              this.video_id = video.id
            }
            break
        }
      } else {
        this.post_link = ''
      }

      if (this.feed.hasOwnProperty('post_videos')) {

        this.post_videos = this.feed.post_videos.data
        if(this.post_videos.length>0)
        {
          this.videoOptions.poster=this.post_videos[this.post_videos.length-1].poster_url

          this.videoOptions.sources[0].src=this.post_videos[this.post_videos.length-1].video1080p
          this.videoOptions.sources[1].src=this.post_videos[this.post_videos.length-1].video720p
          this.videoOptions.sources[2].src=this.post_videos[this.post_videos.length-1].video480p
          this.videoOptions.sources[3].src=this.post_videos[this.post_videos.length-1].video360p
        }

      } else {
        this.post_videos = ''
      }


      this.post_comments = _.reverse(this.feed.post_comments.data)
      this.is_liked = this.feed.is_liked
      this.is_scraped = this.feed.is_scraped
      this.comments = this.feed.post_comments.data
      this.feed_type = this.type
      this.total_post_likes = this.feed.total_post_likes
      this.total_post_scraps = this.feed.total_post_scraps
      this.total_post_comment = this.feed.total_post_comment
    },
    handleCommentPost(newComment) {
      this.post_comments.push(newComment)
      this.feed.total_post_comments++
    },
    onLike() {
      const params = {
        feedId: this.feed.id,
        isLiked: this.is_liked,
        feedType: this.feed_type,
      }
      this.$store
        .dispatch('feed/handleLikeFeed', params)
        .then((response) => {
          this.total_post_likes = response.data.total_post_likes
          this.is_liked = response.data.is_liked
        })
        .catch((error) => {
          console.error(error)
        })
    },
    onScrap() {
      this.post_scrap = {
        post_id: this.feed.id,
        is_scraped: this.is_scraped,
      }
      this.$store
        .dispatch('feed/handleScrapPost', this.post_scrap)
        .then((response) => {
          this.total_post_scraps = response.data.total_post_scraps
          this.is_scraped = response.data.is_scraped
        })
        .catch((error) => {
          console.log(error)
        })
    },
    reportPost() {
      this.report.post_id = this.feed.id
      this.openModal = true
    },
    sharePost() {
      this.urlShare = window.location.origin + '/feed-detail/' + this.feed.id
      this.openModalShare = true
    },
    handleReport(bvModalEvt) {
      if (this.reportStatus) {
        this.resetModal()
        return
      }
      this.content_lenght = 0
      bvModalEvt.preventDefault()
      this.openModal = false
      this.sumitReport()
    },
    resetModal() {
      this.openModal = false
    },
    sumitReport() {
      if ((this.report.type === 'etc') & (this.report.content.length < 2)) {
        this.content_lenght = 2
        return false
      }
      this.loading = true
      this.form_report = {
        content: this.report.content,
        type: this.report.type,
        post_id: this.report.post_id,
      }
      this.$store
        .dispatch('feed/reportPost', this.form_report)
        .then((response) => {
          this.reportStatus = true
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          console.log(error.response)
        })
      // this.$nextTick(() => {
      //   this.$refs.modal.hide()
      // })
    },
    handleDeletePost() {
      let payload = {
        post_id: this.feed.id,
      }
      this.$store
        .dispatch('feed/deleteStatus', payload)
        .then((response) => {
          this.deleted = true
          this.deleted_message = response.data.message
          store.state.authenticate.userProfile.data.post_count--
        })
        .catch((error) => {
          console.log(error)
        })
    },
    resetModalDelete() {
      this.openModalDelete = false
    },
    resetModalShare() {
      this.openModalShare = false
    },
    deletePost() {
      this.openModalDelete = true
    },
    getLink(type) {
      let url = ''
      switch (type) {
        case 1:
          url = 'https://story.kakao.com/s/share?url='
          break

        case 2:
          url = 'https://www.facebook.com/sharer/sharer.php?u='
          break

        case 3:
          url = 'https://twitter.com/intent/tweet?url='
          break
      }
      window.open(url + this.urlShare, '_blank')
    },
    handleCopy() {
      document.querySelector('#_' + this.feed.id).select()
      document.execCommand('copy')
      // window.getSelection().removeAllRanges()
    },
    showModalModify(feed) {
      this.isUpdated = false
      this.isConfirmed = false
      this.$refs['update-' + feed.id].show()
      // this.$refs['form-update-' + feed.id].loadData()
      var ref = this.$refs
      setTimeout(function() { ref['form-update-' + feed.id].loadData() }, 250);
    },
    resetModalModify() {
      this.openModalModify = false
    },
    confirmClose() {
      this.isConfirmed = true
      this.$refs['update-' + this.feed.id].hide()
    },
    closeModalModify(bvModalEvt) {
      if (!this.isConfirmed) {
        bvModalEvt.preventDefault()
        this.$refs['modal-confirm-exit'].show()
      }
    },
    handleUpdatedFeed(feed) {
      this.isConfirmed = true
      this.isUpdated = true
      this.feed = feed

          if (feed.hasOwnProperty('post_videos')) {
            this.post_videos = feed.post_videos.data
            // console.log("feed_hasOwnProperty", this.post_videos);
            if(this.post_videos.length>0)
            {

              // console.log("feed_hasOwnProperty", this.post_videos);
              this.videoOptions.poster=this.post_videos[this.post_videos.length-1].poster_url

              this.videoOptions.sources[0].src=this.post_videos[this.post_videos.length-1].video1080p
              this.videoOptions.sources[1].src=this.post_videos[this.post_videos.length-1].video720p
              this.videoOptions.sources[2].src=this.post_videos[this.post_videos.length-1].video480p
              this.videoOptions.sources[3].src=this.post_videos[this.post_videos.length-1].video360p

              this.videoPlayerKey += 1;
            }
            // console.log("feed_videoOptions", this.videoOptions);

          } else {
            this.post_videos = ''
          }


      this.$refs['update-' + feed.id].hide()
    },
  },
}
</script>
<template>
  <div>
    <b-alert
      v-if="isUpdated"
      variant="success"
      show
      dismissible
    >{{ $t('common.successfully_updated') }}</b-alert>
    <b-alert v-if="deleted" show dismissible>{{ deleted_message }}</b-alert>
    <div v-if="isLoaded && !deleted" :id="id" class="feed-item">
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        size="sm"
        centered
        :busy="loading"
        :visible="openModal"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleReport"
        @cancel="resetModal"
      >
        <template slot="modal-title">{{ $t('modal.report') }}</template>
        <form v-if="!reportStatus" ref="form" @submit.stop.prevent="sumitReport">
          <b-form-group :label="$t('common.reason_report')">
            <b-form-radio-group
              v-model="report.type"
              :options="report.options"
              name="radios-stacked"
              stacked
            ></b-form-radio-group>
          </b-form-group>
          <b-form-textarea
            v-model="report.content"
            rows="3"
            max-rows="6"
            :state="report.content.length >= content_lenght"
          ></b-form-textarea>
        </form>
        <div v-else>{{$t('common.report_success')}}</div>
      </b-modal>
      <b-modal
        id="modal-confirm-exit"
        ref="modal-confirm-exit"
        centered
        :ok-title="`Discard`"
        :cancel-title="`Keep Editing`"
        @ok="confirmClose()"
      >
        <template slot="modal-title">{{$t('modal.confirm_discard_change')}}</template>
        <p>{{$t('modal.confirm_discard_change_content')}}</p>
      </b-modal>
      <b-modal
        :id="`deletePost-${feed.id}`"
        ref="modal"
        centered
        :visible="openModalDelete"
        @show="resetModalDelete"
        @hidden="resetModalDelete"
        @ok="handleDeletePost"
        @cancel="resetModalDelete"
      >
        <template slot="modal-title">{{ $t('modal.confirm') }}</template>
        <p>{{ $t('modal.confirm_delete_post') }}</p>
      </b-modal>
      <b-modal
        :id="`sharePost-${feed.id}`"
        ref="modal"
        centered
        hide-footer
        :visible="openModalShare"
        @show="resetModalShare"
        @hidden="resetModalShare"
      >
        <template slot="modal-title">{{ $t('modal.sharing') }}</template>
        <div class="d-block text-center">
          <ul class="sns_icons">
            <li @click="getLink(1)">
              <img src="@assets/images/icon/icon_share_kakao.png" />
            </li>
            <li @click="getLink(2)">
              <img src="@assets/images/icon/icon_share_facebook.png" />
            </li>
            <li @click="getLink(3)">
              <img src="@assets/images/icon/icon_share_twitter.png" />
            </li>
          </ul>
          <b-form-input :id="'_'+feed.id" v-model="urlShare" rows="3" max-rows="6" />
          <b-button class="mt-3 btn-copy" @click="handleCopy">
            {{
            $t('modal.url_copy')
            }}
          </b-button>
        </div>
      </b-modal>
      <b-modal
        v-if="profile.id === post_author.id"
        :id="`update-${feed.id}`"
        :ref="`update-${feed.id}`"
        size="lg"
        no-close-on-backdrop
        centered
        hide-footer
        @show="resetModalModify"
        @hidden="resetModalModify"
        @hide="closeModalModify"
      >
        <template slot="modal-title">{{ $t('modal.modify') }}</template>
        <ModifyFeed
          :ref="`form-update-${feed.id}`"
          :feed="feed"
          @interfaceUpdateFeed="handleUpdatedFeed"
        />
      </b-modal>
      <div class="info">
        <b-link
          v-if="profile.id !== post_author.id"
          class="link"
          :to="`/profile/${post_author.id}`"
        >
          <div class="img-box">
            <img
              :src="post_author.avatar"
              onerror="this.src='/avatar.png';"
              class="rounded-circle img-fluid"
              :style="{ width: 50 + 'px', height: 50 + 'px' }"
            />
          </div>
          <div class="txt-box">
            <strong>{{ post_author.nick_name }}</strong>
            <b-link class="link" :to="`/feed-detail/${feed.id}`">
              <span class="time">
                {{
                  timeAgoSinceDate(feed.created_at.date)
                }}
              </span>
              <span
                v-if="post_location.name"
              ><span class="location-icon"></span>&nbsp;<span class="bolder">{{ post_location.name }}</span></span>
            </b-link>
          </div>
        </b-link>
        <b-link v-else class="link" :to="`/my-feed`">
          <div class="img-box">
            <img
              :src="post_author.avatar"
              onerror="this.src='/avatar.png';"
              class="rounded-circle img-fluid"
              :style="{ width: 50 + 'px', height: 50 + 'px' }"
            />
          </div>
          <div class="txt-box">
            <strong>{{ post_author.nick_name }}</strong>
            <b-link class="link" :to="`/feed-detail/${feed.id}`">
              <span class="time">
                {{
                timeAgoSinceDate(feed.created_at.date)
                }}
              </span>
              <span
                v-if="post_location.name"
              ><span class="location-icon"></span>&nbsp;<span class="bolder">{{ post_location.name }}</span></span>
            </b-link>
          </div>
        </b-link>

        <b-dropdown right text="setting more" class="setting-more">
          <ul class="more-list">
            <li class="more-share">
              <a class="action" @click="sharePost">
                {{
                $t('common.sharing')
                }}
              </a>
            </li>
            <li v-if="profile.id !== post_author.id" class="more-share">
              <a class="action" @click="reportPost">
                {{
                $t('common.report')
                }}
              </a>
            </li>
            <li v-if="profile.id === post_author.id" class="more-edit">
              <a class="action" @click="showModalModify(feed)">{{ $t('common.to_modify') }}</a>
            </li>
            <li v-if="profile.id === post_author.id" class="more-delete">
              <b-link class="action" @click="deletePost">
                {{
                $t('common.to_delete')
                }}
              </b-link>
            </li>
          </ul>
        </b-dropdown>
      </div>
      <!-- <b-carousel
        v-if="feed.post_images.data.length"
        id="carousel-fade"
        class="slides"
        :interval="0"
        :indicators="feed.post_images.data.length > 1"
        :controls="feed.post_images.data.length > 1"
      >
        <b-carousel-slide
          v-for="(image, index) in feed.post_images.data"
          :key="index"
          :img-src="image.image_url"
          height="480px"
        />
      </b-carousel>-->
      <div class="box">
        <div class="txt">
          <read-more
            v-if="feed.content"
            class="content-read-more"
            :more-str="$t('common.view_more')"
            :text="$options.filters.convertContent(feed.content, feed.post_mentions.data)"
            :less-str="$t('common.view_less')"
            :max-chars="500"
          ></read-more>
          <ImageBlock v-if="feed.post_images.data.length" :images="feed.post_images.data"></ImageBlock>
          <VideoPlayer v-if="feed.post_videos.data.length" :key="videoPlayerKey" :options="videoOptions"/>
          <youtube v-if="video_id && is_youtube" :video-id="video_id" player-width="100%" style="margin-top: 15px;"></youtube>
          <LinkView v-if="feed.post_link && !video_id" :link-info="feed.post_link.data" />

          <ul class="list-icon">
            <li>
              <button
                ref="like"
                type="button"
                class="heart-icon"
                :class="{ active: is_liked }"
                @click="onLike"
              >{{ $tc('common.like_count', total_post_likes, {count: feed.total_post_likes}) }}</button>
            </li>
            <li class="action-comment">
              <button
                type="button"
                class="reply-icon"
              >{{ $tc('common.comment_count', feed.total_post_comments, {count: feed.total_post_comments}) }}</button>
            </li>
            <li>
              <button
                type="button"
                class="scrape-icon"
                :class="{ active: is_scraped }"
                @click="onScrap"
              >{{ $tc('common.scrap_count', total_post_scraps, {count: feed.total_post_scraps}) }}</button>
            </li>
          </ul>
        </div>
      </div>
      <div class="like-total">
        <p>
          {{ $t('common.peoples_like', {count: feed.total_post_likes }) }}
        </p>
      </div>
      <CommentPanel :comments="post_comments" :feed="feed" />
      <CommentForm :feed="feed" :comments="comments" @interface="handleCommentPost" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .location-icon {
  background: url(data:image/png;base64,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) no-repeat;
    background-size: 100% auto;
    background-position-y: 3px;
    width: 12px;
    height: 17px;
    display: inline-block;
}
.bolder {
  font-weight: 600;
  color: black;
  letter-spacing: normal;
}
.modal-body {
  .sns_icons {
    margin: 20px 0;
    text-align: center;
    list-style: none;

    li {
      display: inline;
      margin: 0 10px;
    }
  }

  .btn-copy {
    width: 150px;
    height: 45px;
    font-size: 16px;
    color: #fff;
    border: none;
    background-color: #009bfa;
    cursor: pointer;
  }
}

.link:hover {
  color: #333333;
}

.feed-item {
  border: 1px solid $color-primary-bd;

  /deep/ .carousel-indicators {
    position: static;
    margin: 15px 0;

    li {
      line-height: 0;
      display: block;
      width: 6px;
      height: 6px;
      cursor: pointer;
      color: transparent;
      border: 0;
      border-radius: 50%;
      outline: none;
      background: $color-sub;
      opacity: 1;

      &.active {
        background: $color-primary;
      }
    }
  }
}

.info {
  display: flex;
  justify-content: space-between;
  padding: 20px;

  @include media-breakpoint-down(md) {
    padding: $size-pd-inner-sp;
  }

  .link {
    display: flex;
    align-items: center;

    .img-box {
      margin-right: 10px;
      width: 50px;
      height: 50px;
    }

    .txt-box {
      flex: 1;
      word-break: break-word;

      .time {
        color: $color-date;
        font-size: 14px;
        display: block;
        padding-right: 5px;
      }

      .location {
        color: #8f9094;
        font-size: 12px;
        margin-left: 3px;
        padding-top: 3px;
      }
    }
  }

  .setting-more {
    /deep/ {
      .btn {
        text-indent: -1987em;
        background: transparent url(~@assets/images/icon/icon_more.png)
          no-repeat;
        border-radius: 0;
        border: 0;
        padding: 0;
        margin: 8px 0 0;
        width: 20px;
        height: 20px;

        @include hover-focus {
          outline: 0;
          box-shadow: none;
        }
      }

      .dropdown-menu-right {
        padding: 0;
        margin: 0;
        border: 1px solid $color-primary-bd;
        border-radius: 0;

        .more-list {
          padding: 0;
          margin: 0;
          list-style: none;

          li {
            &:not(:last-child) {
              border-bottom: 1px solid $color-primary-bd;
            }
          }

          .action {
            padding: 8px 8px 8px 20px;
            display: block;
            font-size: 14px;
            color: $color-more;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.box {
  padding: $size-pd;

  @include media-breakpoint-down(md) {
    padding: $size-pd-inner-sp;
  }

  a {
    display: inline-block;
    margin-right: 5px;
    color: $color-primary;

    &.tag-user {
      color: $color-heading-text;
    }

    &.more {
      color: $color-sub;
    }

    &.hashtag {
      display: inline-block;
      margin-right: 5px;
      color: #009bfa;
    }
  }
}

.txt {
  .content-read-more {
    white-space: pre-line;
    word-break: break-all;
  }
}

.txt .hashtag {
  display: inline-block;
  margin-right: 5px;
  color: #009bfa;
}

.list-icon {
  position: relative;
  list-style: none;
  display: flex;
  padding: 15px 0 15px;
  margin: 20px 0 0;
  border-top: 1px solid $color-primary-bd;
  border-bottom: 1px solid $color-primary-bd;

  @include media-breakpoint-down(md) {
    justify-content: space-between;
  }

  li {
    &:not(:first-child) {
      margin-left: 40px;

      @include media-breakpoint-down(md) {
        margin-left: 0;
      }
    }

    // &.action-comment {
    //   position: absolute;
    //   right: 0;
    // }
  }

  button {
    padding-left: 35px;
    line-height: 20px;
    font-size: 14px;
    border: 0;

    @include media-breakpoint-down(md) {
      padding-left: 27px;
    }

    &.heart-icon {
      background: url(~@assets/images/icon/icon_heart.png) no-repeat left center;

      &.active {
        background-image: url(~@assets/images/icon/icon_heart_active.png);
      }

      @include hover() {
        background-image: url(~@assets/images/icon/icon_heart_active.png);
      }
    }

    &.reply-icon {
      background: url(~@assets/images/icon/icon_reply.png) no-repeat left center;

      &.active {
        background-image: url(~@assets/images/icon/icon_reply_active.png);
      }

      @include hover() {
        background-image: url(~@assets/images/icon/icon_reply_active.png);
      }
    }

    &.scrape-icon {
      background: url(~@assets/images/icon/icon_scrape.png) no-repeat left
        center;

      &.active {
        background: url(~@assets/images/icon/icon_scrape_active.png) no-repeat;
      }

      @include hover() {
        background: url(~@assets/images/icon/icon_scrape_active.png) no-repeat;
        outline: 0;
      }
    }
  }
}

.slides {
  width: 100%;
  overflow: hidden;
}

.like-total {
  padding: 0 $size-pd;
  color: $color-sub;
  margin-bottom: 10px;

  @include media-breakpoint-down(md) {
    padding: 0 $size-pd-inner-sp;
  }

  p {
    margin-bottom: 0;
  }

  .number {
    color: $color-like-number;
  }
}
#readmore,
#readmore:hover {
  color: #ae5a2e;
}
</style>
